import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTestTube2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="test-tube 2, test, lab, filter"><path d="M19.0003 9L9.2503 18.75C8.14573 19.8546 6.35487 19.8546 5.2503 18.75C4.14573 17.6454 4.14573 15.8546 5.2503 14.75L15.0003 5" stroke="currentColor" strokeWidth="1.5"/><path d="M13.75 3.25L20.75 10.25" stroke="currentColor" strokeWidth="1.5"/><path d="M8.5 11.75H16" stroke="currentColor" strokeWidth="1.5"/><path d="M10 3.75H3.75V11" stroke="currentColor" strokeWidth="1.5"/><path d="M13 20.25L20.25 20.25L20.25 14" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconTestTube2;
